module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjQzMSIgaGVpZ2h0PSI1Ljk5NyIgdmlld0JveD0iMCAwIDkuNDMxIDUuOTk3Ij4KICA8cGF0aCBpZD0iUGF0aF8yNTE0IiBkYXRhLW5hbWU9IlBhdGggMjUxNCIgZD0iTTgzNC45LDIxNC44NjJsLTMuNDM0LTMuNDM0LTEuMjgyLDEuMjgyLDQuNzE1LDQuNzE1LDQuNzE1LTQuNzE1LTEuMjgyLTEuMjgyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTgzMC4xODIgLTIxMS40MjgpIiBmaWxsPSIjY2MyMDJlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/redDropArrow.svg
// module id = 1680
// module chunks = 1